// extracted by mini-css-extract-plugin
export default {"element":"style-module--element--62545","flexContainer":"style-module--flexContainer--0ca1b"};